import { render, staticRenderFns } from "./TableModal.vue?vue&type=template&id=66fc59d4&scoped=true"
import script from "./TableModal.vue?vue&type=script&lang=js"
export * from "./TableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fc59d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66fc59d4')) {
      api.createRecord('66fc59d4', component.options)
    } else {
      api.reload('66fc59d4', component.options)
    }
    module.hot.accept("./TableModal.vue?vue&type=template&id=66fc59d4&scoped=true", function () {
      api.rerender('66fc59d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/table/TableModal.vue"
export default component.exports